export default [
  {
    id: "CRE",
    color: '',
    summary: 'Documento procesado',
    icon: 'mdi-calendar-blank'
  },
  {
    id: "APR",
    color: '',
    summary: 'Documento aprobado',
    icon: 'mdi-calendar-blank'
  },
  {
    id: "OBS",
    color: '',
    summary: 'Documento aprobado con observaciones',
    icon: 'mdi-calendar-blank'
  },
  {
    id: "DUP",
    color: '',
    summary: 'Documento duplicado',
    icon: 'mdi-calendar-blank'
  },
  {
    id: "REJ",
    color: '',
    summary: 'Documento rechazado',
    icon: 'mdi-calendar-blank'
  },
  {
    id: "RAP",
    color: '',
    summary: 'Documento aprobado por el receptor',
    icon: 'mdi-calendar-blank'
  },
  {
    id: "ROB",
    color: '',
    summary: 'Documento aprobado con discrepancias por el receptor',
    icon: 'mdi-calendar-blank'
  },
  {
    id: "RRJ",
    color: '',
    summary: 'Documento rechazado por el receptor',
    icon: 'mdi-calendar-blank'
  },
  {
    id: "RNO",
    color: '',
    summary: 'Resultado recepción',
    icon: 'mdi-inbox-remove'
  },
  {
    id: "ROK",
    color: '',
    summary: 'Resultado recepción',
    icon: 'mdi-inbox-arrow-down'
  },
  // CEDIDOS
  {
    id: "DCA",
    color: 'blueGreyLighten',
    summary: 'Documento cedido aprobado',
    icon: 'mdi-file-arrow-left-right-outline'
  },
  {
    id: "DCP",
    color: 'blueGreyLighten',
    summary: 'Documento cedido enviado',
    icon: 'mdi-file-arrow-left-right-outline'
  },
  {
    id: "DCE",
    color: 'blueGreyLighten',
    summary: 'Documento cedido con error',
    icon: 'mdi-file-arrow-left-right-outline'
  },
  {
    id: "DCC",
    color: 'blueGreyLighten',
    summary: 'Documento cedido creado',
    icon: 'mdi-file-arrow-left-right-outline'
  },
  {
    id: "DCN",
    color: 'blueGreyLighten',
    summary: 'Documento cedido anulado',
    icon: 'mdi-file-arrow-left-right-outline'
  },
  {
    id: "DCR",
    color: 'blueGreyLighten',
    summary: 'Documento cedido rechazado',
    icon: 'mdi-file-arrow-left-right-outline'
  },
  {
    id: "CTP",
    color: 'blueGreyLighten',
    summary: 'Documento cedido',
    icon: 'mdi-file-arrow-left-right-outline'
  }
]